// Extracted from CadeteCard.tsx — shared iOS scroll-lock hook.
// Uses position:fixed on <body> because overflow:hidden doesn't work in iOS Safari.
import { useEffect } from 'react';

export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;

    const savedScrollY = window.scrollY;
    document.body.style.top = `-${savedScrollY}px`;
    document.body.classList.add('body-scroll-locked');

    return () => {
      document.body.classList.remove('body-scroll-locked');
      document.body.style.top = '';
      window.scrollTo(0, savedScrollY);
    };
  }, [locked]);
}
